import { type FC } from 'react';

import { WinWallMarquee } from './WinWallMarquee';
import { type WinWallOutcomesOrganizationOutcomeSummaryFragment } from './__generated-gql-types__/WinWallOutcomes.generated';

interface WinWallOutcomesProps {
  outcomes: WinWallOutcomesOrganizationOutcomeSummaryFragment[];
}
export const WinWallOutcomes: FC<WinWallOutcomesProps> = ({ outcomes }) => {
  const splitPoint = Math.floor(outcomes.length / 2);
  const topRow = outcomes.slice(0, splitPoint);
  const bottomRow = outcomes.slice(splitPoint);
  return (
    <div className="flex flex-col gap-4">
      <WinWallMarquee outcomes={topRow} />
      <WinWallMarquee outcomes={bottomRow} reverse />
    </div>
  );
};
